import React from 'react';
import ServiceHero from '../../../components/service/ServiceHero';
import QuoteForm from '../../../components/home/QuoteForm';
import ServiceTrusted from '../../../components/service/ServiceTrusted';
import ServicesSection from '../../../components/home/ServicesSection';
import ServiceBenefits from '../../../components/service/serviceBenifits';
import DesireTechSection from '../../../components/home/DesireTechSection';
import ServiceArchitecture from '../../../components/service/ServiceArchitecture';
import ProjectsSection from '../../../components/home/ProjectsSection';
import TestimonialsSection from '../../../components/home/TestimonialsSection';
import ModelsSection from '../../../components/home/ModelsSection';
import OnboardingSection from '../../../components/home/OnboardingSection';
import ServiceHiring from '../../../components/service/ServiceHiring';
import BestArchitectureSection from '../../../components/home/BestArchitectureSection';
import IndustriesSection from '../../../components/home/IndustriesSection';
import ServiceServing from '../../../components/service/serviceserving';
import AwardsSection from '../../../components/home/AwardsSection';
import SoftwaresSection from '../../../components/home/SoftwaresSection';
import FAQSection from '../../../components/home/FAQSection';
import BlogsSection from '../../../components/home/BlogsSection';
import ContactSection from '../../../components/home/ContactSection';
import trustedImg from '../../../assets/img/servicetrusted/1.png';

// Import Industries Icons to fix missing images
import indusIcon1 from '../../../assets/img/indus/Experienced team.png';
import indusIcon2 from '../../../assets/img/indus/Technological Advantage.png';
import indusIcon3 from '../../../assets/img/indus/Effective Communication.png';
import indusIcon4 from '../../../assets/img/indus/Faster Time to Market.png';
import indusIcon5 from '../../../assets/img/indus/High-Quality Standards.png';
import indusIcon6 from '../../../assets/img/indus/Best Value.png';

const ScanToBimServicesCaliforniaPage = () => {
  return (
    <div className="scan-to-bim-services-california-page">
      <style>{`
        .scan-to-bim-services-california-page .hero-content {
          max-width: 1300px !important;
          width: 95% !important;
        }
        .scan-to-bim-services-california-page .service-description {
          max-width: 100% !important;
        }
        .scan-to-bim-services-california-page .desire-tech-subtitle {
          max-width: 850px !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }
        /* Architecture Card Overrides for Centered Look */
        .scan-to-bim-services-california-page .architecture-card {
          text-align: center !important;
          align-items: center !important;
          border: 2px solid #54b248 !important;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
          padding: 25px 20px !important;
        }
        .scan-to-bim-services-california-page .card-icon {
          justify-content: center !important;
          margin-bottom: 20px !important;
        }
        .scan-to-bim-services-california-page .architecture-card h3 {
          font-size: 24px !important;
          text-align: center !important;
          width: 100% !important;
        }
        .scan-to-bim-services-california-page .awards-subtitle {
          max-width: 950px !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }
        .scan-to-bim-services-california-page .softwares-subtitle {
          max-width: 950px !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }
      `}</style>
      <ServiceHero
        overline="Scan to BIM Services California"
        staticTitle={<><span className="text-primary">Professional Scan to BIM Services For</span> Trusted by</>}
        typingWords={["Engineers & Contractors Across California"]}
        description={<>
          We offer Scan-To-BIM services in California, converting point clouds to highly accurate BIM models.
          Our services facilitate design, remodeling, and construction by providing an experts' team,
          precision, quick delivery, and easy collaboration to engineers and contractors who build
          confidently with less error and at a lower cost.
        </>}
        buttonText="Book a Free BIM Quote"
      />

      <QuoteForm />

      <ServiceTrusted
        title={<><span className="text-primary">California's Leading Outsourcing Partner for</span> Scan to BIM Services</>}
        imgSrc={trustedImg}
        paragraphs={[
          "We are a premier provider of Scan to BIM services in California. We offer accurate Scan to BIM services throughout the state that can be used for both construction projects (new and remodels) as well as facility management projects. Our Scan to BIM Service uses state-of-the-art 3D Laser Scanning to create accurate 3D Models that represent the physical condition of a project site.",
          "Our talented team of Scan to BIM Specialists and Experts are considered to be trusted authorities, providing our customers with rapid delivery; minimal design and/or construction errors; and seamless collaboration among Architects, Engineers, General Contractors and Owner/Developers."
        ]}
        buttonText="Get a Free Quote"
      />

      <ServicesSection
        title={<><span className="text-primary">Our Scan to BIM</span> Services in California</>}
        subtitle="We offer a complete range of Scan to BIM services in California, tailored to meet your project requirements:"
      />

      <DesireTechSection
        title={<>Need expert Scan to Revit <span style={{ color: '#54b248' }}>BIM architects and engineers?</span></>}
        subtitle="Access over 50 remote, licensed professionals trained in US standards. They are ready to improve your project's efficiency right away."
        buttonText="Talk to a BIM Expert"
        variant="contactus"
      />

      <ServiceArchitecture
        title={<><span className="text-primary">How our BIM Scan</span> Process Works</>}
        description="We use a defined set of procedures as part of an established workflow to make sure we have a consistent method to deliver a model that meets your expectations for quality, consistency, and timely delivery."
        steps={[
          {
            title: "Initial Project Review",
            description: "First, we want to learn about the details of your project and what level of detail (LOD) you will require in the output BIM file."
          },
          {
            title: "Acquisition of Scan Data",
            description: "Scanning data can be provided via equipped laser scanning or via the provision of point cloud files, markups and reference documentation as appropriate."
          },
          {
            title: "Processing of Point Cloud Data",
            description: "Once the scanning data has been acquired, it will be processed by our staff to ensure that the results will allow us to create an accurate BIM model."
          },
          {
            title: "Creation of BIM Model Using Point Cloud Data",
            description: "We will convert processed scanning data into a detailed Revit BIM model that meets your expectations for scope of work and standard formats."
          },
          {
            title: "Review of Quality of Model",
            description: "All models produced by us will undergo a thorough quality control review to ensure the model meets the required dimensions, consistency and complete readiness for the upcoming phases of the project."
          },
          {
            title: "Delivery of Finished Model",
            description: "You will receive your final BIM model(s) in the required format, ready to add to your Coordination, Design and/or Planning Documentation."
          }
        ]}
      />
      <ServiceBenefits
        title={<><span className="text-primary">Benefits of Scan to</span> BIM for California Projects</>}
        subtitle="California construction and remodeling projects take advantage of speed, regulatory compliance, coordination between disciplines, and precision. This is why scanning to BIM is a popular current workflow for many of today's AEC teams."
        footerText="Scan to BIM can provide your team with the ability to work faster and smarter than ever before through the conversion of real life site conditions into actionable BIM data."
      />

      <ProjectsSection />

      <TestimonialsSection
        title={<><span className="text-primary">Why California</span> Clients Trust Us</>}
        subtitle="Clients rely on BIM models because of time, cost, and quality assurance for any commercial improvement or renovation project in the construction industry. BIM models assist contractors and designers in making sound business decisions about their projects. The use of these models will allow for greater collaboration between contractors and designers, resulting in more efficient building processes."
      />

      <ServiceServing
        title={<><span className="text-primary">Serving Projects</span> Across California</>}
        subtitle="We proudly offer Scan to BIM services throughout California, including major cities and surrounding regions such as:"
        footerText="We will use the same accuracy and professionalism wherever your project is located."
      />
      <ModelsSection />

      <OnboardingSection />

      <ServiceHiring />

      <BestArchitectureSection />

      <DesireTechSection
        title={<><span style={{ color: '#54b248' }}>Ready to Convert Your Scan Data</span> into Accurate BIM Models?</>}
        subtitle="If you are looking for reliable Scan to BIM services in California, our team is ready to help. We deliver precise BIM models that support design clarity, coordination, and faster project execution."
        buttonText="Request Free BIM Quote"
        variant="contactus"
      />

      <IndustriesSection
        title={<><span style={{ color: '#54b248' }}>Why Choose Our</span> Scan to BIM Services?</>}
        subtitle="Choosing the right BIM partner is critical when project decisions depend on model accuracy. Our team focuses on precision, turnaround speed, and practical project support."
        coreValues={[
          {
            title: "Accuracy",
            desc: "Using real-world information captured via laser scanning and point cloud data, we create accurate models that reduce drawing errors and missing information.",
            icon: (
              <div className="anim-float">
                <img src={indusIcon1.src || indusIcon1} alt="Accuracy" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            )
          },
          {
            title: "Speed",
            desc: "We understand how important deadlines are. By streamlining your process we are able to provide accurate BIM models without sacrificing quality.",
            icon: (
              <div className="cog-spin">
                <img src={indusIcon2.src || indusIcon2} alt="Speed" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            )
          },
          {
            title: "Reduced Rework",
            desc: "Having accurate models enables your team to find problems before they arise, improve coordination and avoid costly site revisions later in the construction process.",
            icon: (
              <div className="chat-bounce">
                <img src={indusIcon3.src || indusIcon3} alt="Reduced Rework" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            )
          },
          {
            title: "Custom LODs",
            desc: "Whether you need a concept-level model or one that will be used for fabrication, we will develop models based on your required level of development (LOD).",
            icon: (
              <div className="anim-float">
                <img src={indusIcon4.src || indusIcon4} alt="Custom LODs" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            )
          },
          {
            title: "Software",
            desc: "We can utilize almost any software used in the industry such as Autodesk Revit and will deliver everything in accordance with your specific procedures.",
            icon: (
              <div className="award-shine">
                <img src={indusIcon5.src || indusIcon5} alt="Software" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            )
          },
          {
            title: "Professional Team",
            desc: "Our professionals are experienced in developing architectural, structural and MEP models across many different types of buildings.",
            icon: (
              <div className="dollar-float">
                <img src={indusIcon6.src || indusIcon6} alt="Professional Team" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            )
          }
        ]}
      />

      <AwardsSection />

      <SoftwaresSection />

      <FAQSection
        title={<><span className="text-primary">Frequently Asked Questions</span> (FAQ) – BIM Modeling Services</>}
        faqs={[
          {
            question: "What Is Scan To BIM?",
            answer: "Scan to BIM is the process of converting laser-scanned 3D point cloud data into precise Building Information Models (BIM) using advanced software like Autodesk Revit."
          },
          {
            question: "What File Formats Do You Work With?",
            answer: "We work with various point cloud formats including .RCP, .RCS, .E57, .LAS, and .PTS. Our final deliverables are usually in .RVT, .DWG, .IFC, or .DXF formats as per client needs."
          },
          {
            question: "How Accurate Are Your BIM Models?",
            answer: "Our BIM models capture high-precision details from the scan data, maintaining millimeter-level accuracy to reflect true as-built conditions for renovation or construction."
          },
          {
            question: "Can You Create Architectural, Structural, And MEP BIM Models?",
            answer: "Yes, our expert team specialized in multi-disciplinary BIM modeling, including Architectural, Structural, and MEPF (Mechanical, Electrical, Plumbing, and Fire Protection) systems."
          },
          {
            question: "What Is The Turnaround Time?",
            answer: "The timeline varies based on the project size and Level of Detail (LOD) required. We offer rapid delivery workflows to meet tight project schedules without compromising quality."
          },
          {
            question: "Do You Serve All Of California?",
            answer: "Absolutely. We provide professional Scan to BIM services to engineers, contractors, and architects across all major cities and counties throughout California."
          },
          {
            question: "Have More Questions?",
            answer: "If you have any other specific queries or unique project requirements, our experts are just a call away to provide you with the best solutions."
          }
        ]}
      />

      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default ScanToBimServicesCaliforniaPage;
